/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpRespSimilarItemsGridSeller_sellerItems$ref = any;
export type PdpRespContainer_sellerItems$ref = any;
export type PdpRespContainer_sellerItems = {
    readonly " $fragmentRefs": PdpRespSimilarItemsGridSeller_sellerItems$ref;
    readonly " $refType": PdpRespContainer_sellerItems$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespContainer_sellerItems",
  "type": "moreLikeThisConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsGridSeller_sellerItems",
      "args": null
    }
  ]
};
(node as any).hash = 'ce2dcab9626125ffef79df7339eb9c41';
export default node;
